(() => {
  let isColorTriggered = false;
  let lastActiveSizeId = null;
  let lastActiveColorVariant = null;


$(".select-wrapper:not(.color-wrapper) .item").on("click", function () {
  $(this).siblings(".item").removeClass("active");
  $(this).addClass("active");

  lastActiveSizeId = $(this).attr("data-product-id");

  $(".color-wrapper label").addClass("hide");
  $(`.color-wrapper label[data-product-id='${lastActiveSizeId}']`)
    .removeClass("hide");

  $(".color-wrapper label:not(.hide) input")
    .first()
    .trigger("change");

  $(this)
    .closest(".select-wrapper")
    .prev()
    .find(".selected-value")
    .text($(this).attr("data-product_title"));

});



$("input[name='variant']").on("change", function () {
  const selectedVariant = $(this).val();
  // ✅ Update "Select Colour" selected-value
const selectedColor = $(this).attr("data-variant_title");

$(".color-wrapper")
  .prev("label")
  .find(".selected-value")
  .text(selectedColor);
  lastActiveColorVariant = selectedVariant;

  $("#currentSelection").attr("data-variant", selectedVariant);
  $("#currentSelection").attr("data-price", $(this).attr("data-price"));
  $("#currentSelection").attr("data-compare", $(this).attr("data-compare"));

  const currentPage = $('.product-single_desktop_title .main').text();
  const currentPageStr = currentPage.replace(/\s/g, '');

  // ✅ Voucher logic manually update here, due to it not being dynamic based on products added and if specific variants will have different values as well
  const default200 = ["47432039170275", "47432039203043"];
  const pro200 = ["47432048574691", "47432048607459"];

  let voucherValue;
  let voucherCode;

  if (currentPageStr === "SolarisPro") {
    console.log(currentPageStr);
    if (pro200.includes(selectedVariant)) {
      voucherValue = "200";          
      voucherCode = "RACK200";    
    } else {
      voucherValue = "200";          
      voucherCode = "RACK200";
    }
  } else {
    if (default200.includes(selectedVariant)) {
      voucherValue = "200";          
      voucherCode = "RACK200";
    } else {
      voucherValue = "200";         
      voucherCode = "RACK200";
    }
  }

  // Update data attribute
  $("#currentSelection").attr("data-voucher", voucherValue);

  // Update dynamic code text
  $(".dynamicCode").text(voucherCode);

  if (typeof updateVoucher === "function") updateVoucher();

  // ✅ Restock logic (SAFE)
let restockMessage = '';

if (currentPageStr === 'SolarisPro') {
  console.log('solarisPro');
  const isPreorder = selectedVariant === '47432048607459';

  restockMessage = isPreorder
    ? 'Arrives in Late March'
    : 'Delivers in 1-2 working days';

  if(selectedVariant === '47432048607459'){
    $("#currentSelection").attr("data-stockNum", 3);
  }else{
    $("#currentSelection").attr("data-stockNum", 1);
  }
  
}

if (restockMessage) {
  $(".custom-attributes.product-restocks b").text(restockMessage);
}


  $("input[name='variant']").prop("checked", false);
  $(this).prop("checked", true);

  const url = new URL(window.location.href);
  url.pathname = `/products/${$(this).attr("data-product_handle")}`;
  window.history.replaceState(null, "", url.toString());

  if (typeof updateLinks === "function") updateLinks();
  if (typeof updatePrice === "function") updatePrice();
  if (typeof updateInstallment === "function") updateInstallment();

  restoreActiveSizeIfMissing();
  SelectorUpdateImage();
});



  function restoreActiveSizeIfMissing() {
    const activeItem = $(".select-wrapper:not(.color-wrapper) .item.active");

    if (activeItem.length === 0 && lastActiveSizeId) {
      const fallbackItem = $(
        `.select-wrapper:not(.color-wrapper) .item[data-product-id='${lastActiveSizeId}']`
      );

      if (fallbackItem.length) {
        fallbackItem.addClass("active");
      }
    }
  }

  function SelectorUpdateImage() {
    console.log("Selector Image Update");
    let currentValue = $("#currentSelection").attr("data-variant");

    // If data-variant is empty or missing
    if (!currentValue || currentValue.trim() === "") {
      const url = new URL(window.location.href);
      const variantFromURL = url.searchParams.get("variant");

      if (variantFromURL) {
        currentValue = variantFromURL;
      }
    }

    // ✅ Use currentValue instead of value
    const option = $(`[name='variant'][value='${currentValue}']`);
    const handle = option.attr("data-handle");

    // Remove active-thumb from all thumbnails
    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items").hide();
    // Add active-thumb to the selected variant’s thumbnail
    $(`.product-single__thumbnails-items.main.${handle} a`).addClass(
      "active-thumb"
    );
    $(`.product-single__thumbnails-items.${handle}`).show();
    // Trigger the image change (simulate click)
    $(".product-single__thumbnails-items.main a.active-thumb").click();
  }

  $("input[name='variant']:checked").trigger("change");

  // fix variant image not shown when page loaded
  setTimeout(() => {
    $("input[name='variant']:checked").trigger("change");
  }, 2000);
})();

/* auto select exclusive it show free warranty 
take note of the clickWarranty placement and their different setTimeout. 2000 set for the initial load, 1000 for selectors
*


function clickWarranty() {
  
    $(".addon.autoselect-it-show:not(.hide)").each(function () {
      const input = $(this).find("input[type='checkbox']");

      if (!input.prop("checked")) {
        const label = $(this).find("label.addon-container")[0];
        if (label) label.click();
      }
    });
  
}
*/